import addProductItemSopProductItemsTabImage from "../../../assets/images/add-product-item-sop/add-product-item-sop-product-items-tab.png";
import addProductItemSopProductsListImage from "../../../assets/images/add-product-item-sop/add-product-item-sop-products-list.png";
import addProductItemSopQrCodesImage from "../../../assets/images/add-product-item-sop/add-product-item-sop-qr-codes.png";
import addProductItemSopWizardDetailsImage from "../../../assets/images/add-product-item-sop/add-product-item-sop-wizard-details.png";
import addProductItemSopWizardQuantityImage from "../../../assets/images/add-product-item-sop/add-product-item-sop-wizard-quantity.png";

import type { AddProductItemSopImageConfig } from "../types";

export const ADD_PRODUCT_ITEM_SOP_IMAGES: Record<
  string,
  AddProductItemSopImageConfig
> = {
  "products-list": {
    src: addProductItemSopProductsListImage,
    altKey: "add-product-item-sop-image-products-list-alt",
    altFallback:
      "Products list with a view-details eye icon in the Actions column"
  },
  "product-items-tab": {
    src: addProductItemSopProductItemsTabImage,
    altKey: "add-product-item-sop-image-product-items-tab-alt",
    altFallback:
      "Product Items tab showing stock summary cards and the purple Add Item button"
  },
  "wizard-details": {
    src: addProductItemSopWizardDetailsImage,
    altKey: "add-product-item-sop-image-wizard-details-alt",
    altFallback:
      "Add New Product Item wizard step 1 Details showing quantity, base unit, and pricing fields"
  },
  "wizard-quantity": {
    src: addProductItemSopWizardQuantityImage,
    altKey: "add-product-item-sop-image-wizard-quantity-alt",
    altFallback:
      "Add New Product Item wizard step 2 Quantity showing number of rows and batch summary"
  },
  "qr-codes": {
    src: addProductItemSopQrCodesImage,
    altKey: "add-product-item-sop-image-qr-codes-alt",
    altFallback:
      "QR Codes Generated modal showing a grid of item QR codes with Print, Add More Items, and Done buttons"
  }
};
